import { useChatInputStore } from '@/store';
import { openNewChatComposer } from '@/lib/openHomeComposer';
import { blockIfWorkModeDisabled } from '@/lib/workModeAvailability';

/** Chat ideas send immediately; Work ideas open an editable draft. */
export function openIdeaComposer(router, idea, prompt = idea?.prompt) {
  if (!prompt?.trim()) return false;
  const work = idea?.mode === 'work';
  if (work && blockIfWorkModeDisabled()) return false;
  useChatInputStore.getState().clearPendingAutoSend();
  openNewChatComposer(router, { work });
  useChatInputStore.getState().setText(prompt.trim());
  if (!work) {
    useChatInputStore.setState({ pendingAutoSend: { text: prompt.trim(), action: 'chat' } });
  }
  return true;
}
